import { INTENT_TYPE } from '../constants';
import { type IntentContext, type IntentResponse } from '../types';

import { resolveMatchers } from './resolve-matchers';

/**
 * Classifies a raw input string into a routing decision based on local matchers.
 *
 * This function must remain pure and synchronous. Async layers such as remote
 * intent detection, analytics, logging, and error handling belong in
 * `getInputIntentMultilayer`.
 *
 * @param input Raw, untrimmed user input.
 * @param context Resolved context. Omit for default, product-agnostic behaviour.
 * @returns The detected intent, the pattern that produced it, and whether a matcher claimed it.
 */
export const getInputIntentLocal = (input: string, context: IntentContext = {}): IntentResponse => {
	const trimmed = input.trim();

	const matched = resolveMatchers(context).find((matcher) => matcher.matches(trimmed));

	if (!matched) {
		return {
			didMatch: false,
			type: INTENT_TYPE.FPS,
			pattern: 'NO_PATTERN',
		};
	}

	return {
		didMatch: true,
		type: matched.type,
		pattern: matched.pattern,
	};
};
